import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase";
import { Observable } from "rxjs/Observable";
import { ISponsor } from "../shared/models/sponsor.model";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class SponsorData {

  constructor(
    private afDb: AngularFireDatabase,
    private tracking: TrackingProvider,
  ) { }

  public getSponsorsByClient(client: string): Observable<ISponsor[]> {
    return this.afDb.list<ISponsor>(`Clients/${client}/Sponsors`).
      valueChanges();
  }

  public getSponsorByClient(client: string, sponsorId: string): Observable<ISponsor> {
    return this.afDb.object<ISponsor>(`Clients/${client}/Sponsors/${sponsorId}`).
      valueChanges();
  }

  public getEventSponsor(client: string, id: string): any {
    return this.afDb.object(`Clients/${client}/Sponsors/${id}`).valueChanges();
  }

  public createOrUpdateSponsor(
    client: string,
    object: ISponsor,
    id: string = "",
  ) {
    if (!id) {
      object.created_at = new Date().getTime();
      id = this.afDb.createPushId();
    } else {
      object.update_at = new Date().getTime();
    }

    object.id = id;
    return new Promise((res, rej) => {
      this.afDb.database
        .ref(`Clients/${client}/Sponsors/${id}/`)
        .update(object)
        .then(() => {
          this.tracking.trackEntity(_TRACKING_ENTITIES.SPONSOR, id, client, object);

          return res();
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }

  public getEventSponsorPromise(client: string, id: string): any {
    return firebase.database().ref(`Clients/${client}/Sponsors/${id}`).once("value");
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/sponsor.ts